import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {getProductByText} from '../../data/Products';
import iconBuscador from '../../assets/icons/icon-buscador.svg';
import './style.css';



function SearchIcon({onSubmit}){
    return <img src={iconBuscador} alt="icon" className="icon-search-container" onClick={onSubmit}/>
}

function SearchField(){
    const [inputValue, setInputValue] = useState('');
    const history = useHistory();

    function handleSubmit(){
        const id = getProductByText(inputValue);
        if(id === -1 || id === undefined){
            history.push(`/no-encontrado`);
        } else { history.push(`/productos/${id}`); }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }        
    }

    return <div className="search-field-container">
        <input type="text" placeholder="Qué estás buscando?" value={inputValue} onInput={(e)=>setInputValue(e.target.value)} onKeyDown={handleKeyDown}/>
        <SearchIcon onSubmit={handleSubmit}/>
    </div>
}

export default SearchField;